import { useAppConfig } from '../context/AppConfigContext';
import { Button } from '@/components/ui/button';
import { X, Megaphone } from 'lucide-react';

export default function AnnouncementPopup() {
  const { config, showPopup, dismissPopup } = useAppConfig();
  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 z-[70] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-white dark:bg-slate-800 rounded-2xl border border-gray-200 dark:border-slate-700 shadow-2xl max-w-md w-full p-6 relative">
        <button
          onClick={dismissPopup}
          className="absolute top-4 right-4 p-1.5 rounded-full text-gray-400 hover:text-gray-600 dark:hover:text-slate-200 hover:bg-gray-100 dark:hover:bg-slate-700 transition"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-cyan-100 dark:bg-cyan-900/30 flex items-center justify-center">
            <Megaphone className="w-5 h-5 text-cyan-600 dark:text-cyan-400" />
          </div>
          <h2 className="text-lg font-bold text-gray-900 dark:text-white">{config.popup_title}</h2>
        </div>

        <p className="text-gray-600 dark:text-slate-300 text-sm leading-relaxed mb-6 whitespace-pre-wrap">
          {config.popup_body}
        </p>

        <Button onClick={dismissPopup} className="w-full bg-cyan-600 hover:bg-cyan-700 text-white">
          Got it!
        </Button>
      </div>
    </div>
  );
}